// extracted by mini-css-extract-plugin
module.exports = {"topicBlock":"TopicBlock_topicBlock__mBQXZ","text":"TopicBlock_text__1nrDt","actions":"TopicBlock_actions__1ElY6","action":"TopicBlock_action__3clKH"};